<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Log Details'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="request?.method + ' ' + request?.path" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'Status: '" />
          <tidy-text
            [body]="response?.status_code" />
          <tidy-row>
            <tidy-text
              [helper]="'ID: '" />
            <tidy-text
              [body]="id" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="'Time: '" />
            <tidy-text
              [body]="timestamp | parseDateTime:'dddd MMM d':'local'" /><span>&nbsp;</span>
              <tidy-text
                [body]="timestamp | parseDateTime:'h:mma':'local'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="'Origin: '" />
              <tidy-text
                [body]="('https://' | translate) + request?.headers?.Host" />
            </tidy-row>
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'Response body'" />
          </tidy-row>
          <tidy-row>
            <tidy-json-formatter [dataJson]="responseBodyJSON" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="('Request ' | translate) + request?.method + (' body' | translate)" />
          </tidy-row>
          <tidy-row>
            <tidy-json-formatter [dataJson]="requestBodyJSON" />
          </tidy-row>
        </tidy-card>
      }
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
